import { useEffect, useState } from "react";

// useDocumentVisible returns whether the tab is currently visible, and
// re-renders the component when that changes. Use it to gate side effects that
// must only happen while someone is looking, such as marking a message read:
// a poll that lands while the tab is hidden must not create a read receipt for
// a message nobody has seen, and switching back to the tab must create it even
// if the data didn't change (no new data means no re-render without this).
export function useDocumentVisible() {
  const [visible, setVisible] = useState(
    () => typeof document === "undefined" || !document.hidden,
  );

  useEffect(() => {
    const onChange = () => setVisible(!document.hidden);
    onChange();
    document.addEventListener("visibilitychange", onChange);
    return () => document.removeEventListener("visibilitychange", onChange);
  }, []);

  return visible;
}
